import classNames from 'clsx'
import { bool, func, node, string } from 'prop-types'

import Button from 'views/components/atoms/Button'

import './ButtonFilter.scss'

const ButtonFilter = props => {
  const { children, transparent, ...rest } = props
  const classes = classNames('m-ButtonFilter', {
    'm-ButtonFilter__transparent': transparent,
  })

  return (
    <Button {...rest} className={classes}>
      {children}
    </Button>
  )
}

ButtonFilter.propTypes = {
  children: node.isRequired,
  onClick: func.isRequired,
  ariaPressed: string,
  transparent: bool,
}

ButtonFilter.defaultProps = {
  ariaPressed: null,
  transparent: false,
}

export default ButtonFilter
